import { ErrorBoundary } from 'react-error-boundary';
import { trackError } from 'utils/helpers';
import { bookingFormFallbackRender } from 'components/error_boundary';
import { BookingForm } from './booking_form';

const BookingFormWithErrorBoundary = (props) => (
  <ErrorBoundary
    fallbackRender={bookingFormFallbackRender}
    onError={trackError}
  >
    <BookingForm
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  </ErrorBoundary>
);

export default BookingFormWithErrorBoundary;
